
<template>
  <BreadCrumb PageTitle="Coupon" />
  <div class="row" v-if="user">
    <div class="col-xxl-12">
      <NewLocationContent />
    </div>
  </div>
</template>

<script setup>

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import NewLocationContent from "../../components/Admin/NewLocation/NewLocationContent.vue";

import { useAccountStore } from "@/stores"
import { storeToRefs } from 'pinia';
const accountStore = useAccountStore();
const { user } = storeToRefs(accountStore);
</script>